/**
 * !Important! Every time will add a new sequence here,
 * should be created that sequence also to the firebase
 * under the collection 'sequences'.
 */
export enum SequenceType {
  GENERAL = 'general'
}
